/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useRussianPokerStore } from '../../providers/RussianPokerProvider'
import { numberWithSpaces } from '../../utils/number'
import { ArrowRightIcon } from '../Icons'
import { Typography } from '../Typography'

export const LimitsBtn: FC = observer(() => {
  const {
    uiStore,
    game: {
      config: { limit },
    },
  } = useRussianPokerStore()
  const { showPaymentsTable, togglePaymentsTable } = uiStore

  return (
    <button
      type="button"
      onClick={togglePaymentsTable}
      css={css`
        all: unset;
        display: inline-flex;
        align-items: center;
        opacity: ${showPaymentsTable ? 0.5 : 1};
        cursor: pointer;
      `}>
      <Typography variant="top" as="span">
        Min {limit.min} - Max{' '}
        {limit.max === null ? 'unlim' : numberWithSpaces(limit.max)}&nbsp;&nbsp;
      </Typography>
      <ArrowRightIcon
        size={{
          mobile: '4px',
          tablet: '7px',
          desktop: '10px',
        }}
        color={showPaymentsTable ? 'gold1' : 'white'}
        css={css`
          transform: ${showPaymentsTable ? 'rotate(180deg)' : 'rotate(0deg)'};
        `}
      />
    </button>
  )
})
